import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const Airplane = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M14 8.95 22 14v2l-8-2.53v5.36l3 1.67V22l-4.5-1L8 22v-1.5l3-1.67v-5.36L3 16v-2l8-5.05V3.5a1.5 1.5 0 1 1 3 0v5.45Z"
    />
  </svg>
));
